import { render } from "./page_row.vue?vue&type=template&id=afbaae5e&scoped=true&lang=pug"
import script from "./page_row.vue?vue&type=script&lang=js"
export * from "./page_row.vue?vue&type=script&lang=js"

import "./page_row.vue?vue&type=style&index=0&id=afbaae5e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afbaae5e"]])

export default __exports__